/**
 * managers.js
 */

import React from 'react';
import {
  useMediaQuery,
  IconButton,
  List
} from '@mui/material';
import { parseISO, format } from 'date-fns';
import Icon from 'components/icon';
import DropMenu from 'components/drop-menu';
import DataGrid from 'components/data-grid';
import NameCell from './name-cell';
import RowMobile from './row-mobile';



export default function Managers(props) {
  const {
    managers,
    onRemove,
  } = props;
  const isMobile = useMediaQuery(theme => theme.breakpoints.down('sm'), { noSsr: true });


  const managersMenu = (row) => {
    const items = [];
    items.push({
      id: 'remove',
      icon: 'delete',
      name: 'Remove ...',
      onSelect: () => onRemove(row.role.id, row.manager.id, row.user.id, {
        userType: 'Manager',
        text: `remove ${row.manager.name} from having supervisor management access to your account`
      })
    });

    return (<DropMenu
      id={`${row.id}-pending-menu`}
      label={<IconButton size='small'><Icon type='menu' /></IconButton>}
      items={items}
    />);
  }


  const columnDefs = [{ 
    field: 'name',
    headerName: 'Name',
    width: 200,
    valueGetter: (params) => params.row.manager.name,
    renderCell: (params) => (<NameCell 
      name={params.row.manager.name} 
      department={params.row.manager.departmentName} 
    />),
  }, {
    field: 'email',
    headerName: 'Email',
    width: 200,
    valueGetter: params => params.row.manager.email
  }, {
    field: 'dateApproved',
    headerName: 'Since',
    width: 120,
    valueGetter: params => format(parseISO(params.row.dateCreated), 'MM/dd/yyyy')
  }, {
    field: 'menu',
    headerName: ' ',
    sortable: false,
    align: 'right',
    width: 95,
    minWidth: 95,
    renderCell: (params) => managersMenu(params.row),
  }];


  return (
    <>
      {/* MOBILE */}
      {isMobile && 
      <List>
        {managers.map((row, i) => <RowMobile
          key={i}
          nameContent={<NameCell name={row.manager.name} department={row.manager.departmentName} />}
          menu={managersMenu(row)}
        />)}
      </List>}

      {/* DESKTOP */}
      {!isMobile &&
      <DataGrid
        rows={managers}
        columns={columnDefs}
        headerHeight={48}
        rowHeight={48}
        autoHeight
        disableColumnMenu
        disableRowSelectionOnClick
        hideFooter
        hideFooterSelectedRowCount
      />}
    </>
  );
}